<template>
<div>
  <div class="page-header">
    <div class="page-leftheader">
      <div class="headline">
        <h4 class="page-title text-primary">Meldungen</h4>
        <!--
          WAR FALSCH: Hier stand "Mehrfach gemeldete Einträge stehen oben." Das
          stimmt nicht — sortiert wird serverseitig nach dem Zeitpunkt der
          jüngsten Meldung (lastReportedAt, absteigend), nicht nach der
          Anzahl (ETSBackend/controllers/v1/userActionController.js,
          reportDetailWithLimit). Ein Eintrag mit fünf alten Meldungen kann
          damit weit unter einem mit nur einer ganz aktuellen stehen. Wer sich
          auf den Text verließ und nur die obersten Zeilen bearbeitete,
          übersah genau die Fälle, auf die es ankam. Eine Sortierung nach
          Anzahl bräuchte eine Änderung am Server (nicht Teil dieser Datei) —
          bis dahin beschreibt der Text hier ehrlich, wonach tatsächlich
          sortiert wird.
        -->
        <p class="page-subtitle mb-0">
          Was Mitglieder gemeldet haben — mit Melder, Grund und Zeitpunkt.
          Die zuletzt gemeldeten Einträge stehen oben — unabhängig davon, wie
          oft insgesamt gemeldet wurde. Die Zahl in der Spalte "Anzahl" zeigt
          das gesondert an.
        </p>
      </div>
    </div>
  </div>

  <div class="mb-3">
    <v-tabs v-model="reportTab">
      <v-tab href="#tab-1" @click="chooseReportType('user')">Gemeldete Benutzer</v-tab>
      <v-tab href="#tab-2" @click="chooseReportType('post')">Gemeldete Beiträge</v-tab>
      <v-tab href="#tab-3" @click="chooseReportType('trip')">Gemeldete Touren</v-tab>
      <!-- Routen liessen sich in der App schon immer melden, hatten hier aber
           keinen Reiter — die Meldungen kamen nie bei jemandem an. -->
      <v-tab href="#tab-4" @click="chooseReportType('route')">Gemeldete Strecken</v-tab>
    </v-tabs>
  </div>
  <div>
    <div>
        <input v-model="search" type="search" class="form-control form-control-sm" placeholder="Suche..." aria-controls="example1">
        <br>
    </div> 
    <div>
           
      <div>
        <div class="card">
          <div class="table-responsive">
            <table class="table card-table table-vcenter" v-if="this.reportType == 'post'">
              <thead>
                <tr>
                  <th>Gemeldeter Beitrag</th>
                  <th>Beschreibung</th>
                  <th class="text-center">Anzahl</th>
                  <th class="reporters-head">Gemeldet von — Grund und Zeitpunkt</th>
                  <th>Aktion</th>
                  <th>Bearbeitet</th>
                </tr>
              </thead>
              <tbody>
              <!--
                Vier Zustände in EINER Kette: lädt · Abruf gescheitert · nichts
                gefunden · Ergebnisse. Dieselbe Kette steht in allen vier
                Reitern dieser Datei.

                WAR FALSCH (Runde 1): Es gab nur "ist die Liste leer?" — das
                trifft VOR der Antwort genauso zu wie NACH einem Fehlschlag.

                WAR FALSCH (Runde 2): Die Zustandszeilen bildeten eine Kette,
                die Datenzeilen standen aber daneben und wurden immer
                gezeichnet. Scheiterte ein Abruf — vor allem beim Wechsel des
                Reiters —, stand oben die rote Fehlerzeile und darunter
                unverändert die Liste des VORHERIGEN Reiters, also z. B. Zeilen
                gemeldeter Benutzer unter den Spaltenköpfen für gemeldete
                Beiträge. Jetzt hängen die Datenzeilen als v-else an derselben
                Kette; zusätzlich leert chooseReportType() die Liste beim
                Reiterwechsel (siehe dort).

                WICHTIG: Zwischen die Glieder dieser Kette gehört kein
                Kommentar — Vue verbindet v-else-if/v-else nur mit dem direkt
                davorstehenden Geschwisterelement (siehe ausführliche Notiz in
                Users.vue).
              -->
              <tr v-if="loading && reports.length === 0">
                <td colspan="6" class="text-center text-muted">Wird geladen …</td>
              </tr>
              <tr v-else-if="fetchError">
                <td colspan="6" class="text-center text-danger">{{ fetchError }}</td>
              </tr>
              <tr v-else-if="reports.length === 0">
                <td colspan="6" class="text-center text-muted">Keine gemeldeten Beiträge gefunden.</td>
              </tr>
              <template v-else>
              <tr v-for="report in reports" :key="report._id">
                <td class="align-middle">
                    <!-- Ein gemeldeter Beitrag ohne Bild ließ zuvor den ganzen
                         Reiter weiß werden: Der Zugriff auf das erste Element
                         warf, das Modell erlaubt aber ein leeres Array. -->
                    <img
                    :src="`${$img(firstImage(report), $awsLargeImages)}`"
                    alt=""
                    class="avatar avatar-md brround"
                    />
                </td>
                <td class="align-middle tableAbout">{{report.description}}</td>
                <td class="align-middle text-center">
                  <span class="badge badge-danger">{{ reportCount(report) }}</span>
                </td>
                <td class="align-middle reporters-cell">
                  <div
                    class="reporter-entry"
                    v-for="reporter in visibleReporters(report)"
                    v-bind:key="reporter.reportId"
                  >
                    <img
                      v-bind:src="`${$img(reporter.image, $awsSmallImages)}`"
                      class="avatar avatar-sm brround mr-2"
                      alt=""
                    />
                    <div>
                      <div>{{ reporter.userName }}</div>
                      <!-- title zeigt den Freitext (details) als Tooltip beim
                           Überfahren — für die volle Ansicht "Meldung ansehen"
                           öffnen (dort steht er auch als Text). -->
                      <small class="text-muted" v-bind:title="reporter.details || ''">
                        {{ reasonLabel(reporter.reason) }} &middot;
                        {{ $formatDate(reporter.reportedAt) }}
                      </small>
                    </div>
                  </div>
                  <small class="text-muted" v-if="hiddenReporterCount(report) > 0">
                    und {{ hiddenReporterCount(report) }} weitere
                  </small>
                </td>
                <td class="align-middle">
                    <a
                      title="Meldung ansehen"
                      class="btn btn-primary btn-small mr-1"
                      @click="openViewReport(report)"
                      ><i class="fas fa-expand"></i
                    ></a>
                    <a
                      title="Meldung löschen"
                      class="btn btn-small btn-danger"
                      @click="openDeleteReport(report)"
                      ><i class="fas fa-trash-alt"></i
                    ></a>
                  </td>
                <td class="align-middle">
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" @click="setChecked(report, $event)"/>
                      <span class="custom-control-label"></span>
                    </label>
                </td>
              </tr>
              </template>
            </tbody>
            </table>
            <table class="table card-table table-vcenter" v-if="this.reportType == 'user'">
              <thead>
                <tr>
                  <th>Gemeldeter Benutzer</th>
                  <th>E-Mail</th>
                  <th class="text-center">Anzahl</th>
                  <th class="reporters-head">Gemeldet von — Grund und Zeitpunkt</th>
                  <th>Aktion</th>
                  <th>Bearbeitet</th>
                </tr>
              </thead>
              <tbody>
              <tr v-if="loading && reports.length === 0">
                <td colspan="6" class="text-center text-muted">Wird geladen …</td>
              </tr>
              <tr v-else-if="fetchError">
                <td colspan="6" class="text-center text-danger">{{ fetchError }}</td>
              </tr>
              <tr v-else-if="reports.length === 0">
                <td colspan="6" class="text-center text-muted">Keine gemeldeten Benutzer gefunden.</td>
              </tr>
              <template v-else>
              <tr v-for="report in reports" :key="report._id">
                <td class="align-middle">
                  <div class="reporter-entry">
                    <img
                      :src="`${$img(report.image,$awsLargeImages)}`"
                      alt="img"
                      class="avatar avatar-md brround mr-2"
                    />
                    <div>
                      <div>{{report.userName}}</div>
                      <small class="text-muted reported-about">{{report.about}}</small>
                    </div>
                  </div>
                </td>
                <td class="align-middle">{{report.email}}</td>
                <td class="align-middle text-center">
                  <span class="badge badge-danger">{{ reportCount(report) }}</span>
                </td>
                <td class="align-middle reporters-cell">
                  <div
                    class="reporter-entry"
                    v-for="reporter in visibleReporters(report)"
                    v-bind:key="reporter.reportId"
                  >
                    <img
                      v-bind:src="`${$img(reporter.image, $awsSmallImages)}`"
                      class="avatar avatar-sm brround mr-2"
                      alt=""
                    />
                    <div>
                      <div>{{ reporter.userName }}</div>
                      <!-- title zeigt den Freitext (details) als Tooltip beim
                           Überfahren — für die volle Ansicht "Meldung ansehen"
                           öffnen (dort steht er auch als Text). -->
                      <small class="text-muted" v-bind:title="reporter.details || ''">
                        {{ reasonLabel(reporter.reason) }} &middot;
                        {{ $formatDate(reporter.reportedAt) }}
                      </small>
                    </div>
                  </div>
                  <small class="text-muted" v-if="hiddenReporterCount(report) > 0">
                    und {{ hiddenReporterCount(report) }} weitere
                  </small>
                </td>
                <td>
                    <a
                      class="btn btn-primary btn-small mr-1"
                      @click="openViewReport(report)"
                      ><i class="fas fa-expand"></i
                    ></a>
                    <a
                      class="btn btn-small btn-danger"
                      @click="openDeleteReport(report)"
                      ><i class="fas fa-trash-alt"></i
                    ></a>
                  </td>
                  <td class="align-middle">
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" @click="setChecked(report, $event)"/>
                      <span class="custom-control-label"></span>
                    </label>
                </td>
              </tr>
              </template>
            </tbody>
            </table>
            <table class="table card-table table-vcenter" v-if="this.reportType == 'trip'">
              <thead>
                <tr>
                  <th>Gemeldete Tour</th>
                  <th>Beschreibung</th>
                  <th class="text-center">Anzahl</th>
                  <th class="reporters-head">Gemeldet von — Grund und Zeitpunkt</th>
                  <th>Aktion</th>
                  <th>Bearbeitet</th>
                </tr>
              </thead>
              <tbody>
              <tr v-if="loading && reports.length === 0">
                <td colspan="6" class="text-center text-muted">Wird geladen …</td>
              </tr>
              <tr v-else-if="fetchError">
                <td colspan="6" class="text-center text-danger">{{ fetchError }}</td>
              </tr>
              <tr v-else-if="reports.length === 0">
                <td colspan="6" class="text-center text-muted">Keine gemeldeten Touren gefunden.</td>
              </tr>
              <template v-else>
              <tr v-for="report in reports" :key="report._id">
                <td class="align-middle">
                  <div class="reporter-entry">
                    <img
                      :src="`${$img(report.image,$awsLargeImages)}`"
                      alt="img"
                      class="avatar avatar-md brround mr-2"
                    />
                    <div>
                      <div>{{report.title}}</div>
                      <!-- Trips.vue übersetzt denselben Rohwert ("1 point"/"2 point")
                           an dieser Stelle nicht — hier stand der englische
                           Kategoriewert unübersetzt mitten im deutschen Dashboard. -->
                      <small class="text-muted">{{report.category == '1 point' ? '1 Punkt' : report.category == '2 point' ? '2 Punkte' : report.category}}</small>
                    </div>
                  </div>
                </td>
                <td class="align-middle tableAbout">{{report.description}}</td>
                <td class="align-middle text-center">
                  <span class="badge badge-danger">{{ reportCount(report) }}</span>
                </td>
                <td class="align-middle reporters-cell">
                  <div
                    class="reporter-entry"
                    v-for="reporter in visibleReporters(report)"
                    v-bind:key="reporter.reportId"
                  >
                    <img
                      v-bind:src="`${$img(reporter.image, $awsSmallImages)}`"
                      class="avatar avatar-sm brround mr-2"
                      alt=""
                    />
                    <div>
                      <div>{{ reporter.userName }}</div>
                      <!-- title zeigt den Freitext (details) als Tooltip beim
                           Überfahren — für die volle Ansicht "Meldung ansehen"
                           öffnen (dort steht er auch als Text). -->
                      <small class="text-muted" v-bind:title="reporter.details || ''">
                        {{ reasonLabel(reporter.reason) }} &middot;
                        {{ $formatDate(reporter.reportedAt) }}
                      </small>
                    </div>
                  </div>
                  <small class="text-muted" v-if="hiddenReporterCount(report) > 0">
                    und {{ hiddenReporterCount(report) }} weitere
                  </small>
                </td>
                <td>
                    <a
                      class="btn btn-primary btn-small mr-1"
                      @click="openViewReport(report)"
                      ><i class="fas fa-expand"></i
                    ></a>
                    <a
                      class="btn btn-small btn-danger"
                      @click="openDeleteReport(report)"
                      ><i class="fas fa-trash-alt"></i
                    ></a>
                  </td>
                  <td class="align-middle">
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" @click="setChecked(report, $event)" />
                      <span class="custom-control-label"></span>
                    </label>
                </td>
              </tr>
              </template>
            </tbody>
            </table>

            <!-- Gemeldete Strecken. Anders als Touren haben sie kein
                 `image`-Feld und keine Kategorie (siehe
                 ETSBackend/models/Route.js) — die Spalten entfallen deshalb.
                 `galleryImages` gibt es zwar im Datenmodell, der
                 Strecken-Zweig im Backend liefert sie aber nicht mit. -->
            <table class="table card-table table-vcenter" v-if="this.reportType == 'route'">
              <thead>
                <tr>
                  <th>Gemeldete Strecke</th>
                  <th>Beschreibung</th>
                  <th class="text-center">Anzahl</th>
                  <th class="reporters-head">Gemeldet von — Grund und Zeitpunkt</th>
                  <th>Aktion</th>
                  <th>Bearbeitet</th>
                </tr>
              </thead>
              <tbody>
              <tr v-if="loading && reports.length === 0">
                <td colspan="6" class="text-center text-muted">Wird geladen …</td>
              </tr>
              <tr v-else-if="fetchError">
                <td colspan="6" class="text-center text-danger">{{ fetchError }}</td>
              </tr>
              <tr v-else-if="reports.length === 0">
                <td colspan="6" class="text-center text-muted">Keine gemeldeten Strecken gefunden.</td>
              </tr>
              <template v-else>
              <tr v-for="report in reports" :key="report._id">
                <td class="align-middle">
                  {{ report.title || 'ohne Titel' }}
                </td>
                <td class="align-middle tableAbout">{{report.description}}</td>
                <td class="align-middle text-center">
                  <span class="badge badge-danger">{{ reportCount(report) }}</span>
                </td>
                <td class="align-middle reporters-cell">
                  <div
                    class="reporter-entry"
                    v-for="reporter in visibleReporters(report)"
                    v-bind:key="reporter.reportId"
                  >
                    <img
                      v-bind:src="`${$img(reporter.image, $awsSmallImages)}`"
                      class="avatar avatar-sm brround mr-2"
                      alt=""
                    />
                    <div>
                      <div>{{ reporter.userName }}</div>
                      <!-- title zeigt den Freitext (details) als Tooltip beim
                           Überfahren — für die volle Ansicht "Meldung ansehen"
                           öffnen (dort steht er auch als Text). -->
                      <small class="text-muted" v-bind:title="reporter.details || ''">
                        {{ reasonLabel(reporter.reason) }} &middot;
                        {{ $formatDate(reporter.reportedAt) }}
                      </small>
                    </div>
                  </div>
                  <small class="text-muted" v-if="hiddenReporterCount(report) > 0">
                    und {{ hiddenReporterCount(report) }} weitere
                  </small>
                </td>
                <td>
                    <!-- Fehlte: Nur der Löschknopf stand hier. `openViewReport`
                         ist die einzige Stelle, die `viewDialog` öffnet — ohne
                         diesen Knopf war der Dialog „Meldung ansehen" im
                         Strecken-Reiter gar nicht erreichbar. Ab vier Meldern
                         steht in der Zeile nur noch „und N weitere"; wer wissen
                         wollte, wer das war, hatte keinen Weg dorthin. -->
                    <a
                      title="Meldung ansehen"
                      class="btn btn-primary btn-small mr-1"
                      @click="openViewReport(report)"
                      ><i class="fas fa-expand"></i
                    ></a>
                    <a
                      title="Meldung löschen"
                      class="btn btn-small btn-danger"
                      @click="openDeleteReport(report)"
                      ><i class="fas fa-trash-alt"></i
                    ></a>
                  </td>
                  <td class="align-middle">
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" @click="setChecked(report, $event)" />
                      <span class="custom-control-label"></span>
                    </label>
                </td>
              </tr>
              </template>
            </tbody>
            </table>
          </div>

        </div>
        <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
      </div>

      <v-dialog 
        v-model="viewDialog"
        width="500"
        >
        <v-card>
          <v-card-title class="card">
              <h4 class="page-title text-primary">Meldung ansehen</h4>
            </v-card-title>
            <v-card-text>
                <div v-if="this.reportType == 'user'" class="form-group">
                  <label class="form-label">Benutzername</label>
                  <!-- readonly, nicht disabled: Der Dialog heisst „Meldung ansehen",
                       der Text soll lesbar und markierbar bleiben (etwa um eine
                       E-Mail herauszukopieren). Zuvor stand hier fuenfmal
                       „disababled" — ein Tippfehler, den der Browser stillschweigend
                       ignoriert. FOLGE: Die Felder waren bearbeitbar und schrieben
                       ueber v-model direkt in die Tabellenzeile dahinter, denn
                       openViewReport setzt viewReport auf genau dieses Objekt.
                       Gespeichert wurde nichts — die Verwaltung sah danach aber
                       andere Werte, als in der Datenbank stehen. -->
                  <input class="form-control" type="text" v-model="viewReport.userName" readonly>
                </div>
                <!-- Fehlte: 'route' war hier nicht aufgeführt. Der Dialog zeigte
                     bei einer gemeldeten Strecke keinen einzigen Hinweis darauf,
                     WELCHE Strecke gemeldet wurde — nur Beschreibung und Melder. -->
                <div v-if="this.reportType == 'trip' || this.reportType == 'route'" class="form-group">
                  <label class="form-label">Name</label>
                  <input class="form-control" type="text" v-model="viewReport.title" readonly>
                </div>
                <!-- Der ganze Bildblock entfällt bei Strecken: Sie haben kein
                     `image`-Feld (ETSBackend/models/Route.js), und der
                     Strecken-Zweig im Backend liefert auch keine
                     `galleryImages`. Zuvor griff hier der Zweig „alles ausser
                     post" — `$img('')` fällt in main.js auf
                     /images/brand/favicon.png zurück, der Betrachter sah also
                     das App-Symbol und hielt es für ein Streckenbild. -->
                <div class="form-group" v-if="this.reportType != 'route'">
                  <div v-if="this.reportType != 'post'">
                    <label class="form-label">Bild</label>
                    <img
                        :src="`${$img(viewReport.image,$awsLargeImages)}`"
                        alt="img"
                        class="avatar avatar-xxl brround"
                    />
                  </div>
                    <b-carousel
                      :interval="0"
                      controls
                      indicators
                      no-animation
                      v-else
                    >
                        <!-- Schluessel ist der Index, nicht img.url: Ein Beitrag
                             darf dieselbe Bildadresse zweimal enthalten (kommt in
                             den Testdaten vor). Vue warnt dann „Duplicate keys
                             detected" und kann die Bilder beim Blaettern
                             verwechseln. Der Index ist hier eindeutig und stabil,
                             weil die Liste im Dialog nicht umsortiert wird. -->
                        <b-carousel-slide
                          v-for="(img, imgIndex) in viewReport.galleryImages" :key="imgIndex"
                          :img-src="`${$img(img.url,$awsLargeImages)}`"
                        ></b-carousel-slide>
                    </b-carousel>
                </div>
                <div class="form-group">
                  <label class="form-label">Beschreibung</label>
                  <input class="form-control" type="text" v-model="viewReport.about" readonly v-if="this.reportType == 'user'">
                  <input class="form-control" type="text" v-model="viewReport.description" readonly v-if="this.reportType != 'user'">
                </div>
                <div class="form-group">
                  <label class="form-label">Gemeldet von — Grund und Zeitpunkt</label>
                  <!-- Grund und Zeitpunkt liegen je Melder vor (siehe Tabelle
                       oben, dieselben Felder), nicht als ein einzelnes Feld
                       auf der Meldung selbst. Der auskommentierte Block hier
                       griff auf das nicht existierende viewReport.reason zu
                       und wurde deshalb nie angezeigt — die Detailansicht
                       zeigte Grund und Zeitpunkt komplett gar nicht an. -->
                  <div
                    class="reporter-entry mb-1"
                    v-for="reportingUser in viewReport.data"
                    :key="reportingUser.reportId || reportingUser._id"
                  >
                    <div>{{ reportingUser.userName }}</div>
                    <small class="text-muted">
                      {{ reasonLabel(reportingUser.reason) }} &middot;
                      {{ $formatDate(reportingUser.reportedAt) }}
                    </small>
                    <!-- Der eigentliche Freitext, WARUM gemeldet wurde — bisher
                         zwar in der Datenbank und in der Mail, aber im
                         Dashboard nirgends sichtbar. -->
                    <div class="text-muted" v-if="reportingUser.details">{{ reportingUser.details }}</div>
                  </div>
                </div>
            </v-card-text>
            <v-divider></v-divider>
          <v-card-actions>
              <v-spacer></v-spacer>
              <a class="btn btn-primary btn-pill mr-1" @click="viewDialog=false">Schließen</a>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog 
        v-model="deleteDialog"
        width="500">
        <!--
          Der Knopf löscht nicht die Meldung, sondern das gemeldete Objekt —
          bei Nutzern das gesamte Konto samt Fahrzeugen, Touren, Beiträgen,
          Kommentaren, Nachrichten und Verbindungen. Der Dialog sprach zuvor
          nur von „diese Meldung löschen"; wer eine unbegründete Meldung
          wegräumen wollte, löschte damit den gemeldeten Nutzer.
        -->
        <v-card>
          <v-card-title class="card">
              <h4 class="page-title text-danger">{{ deleteDialogTitle }}</h4>
            </v-card-title>
            <v-card-text>
              <div class="delete-warning">
                <i class="fe fe-alert-triangle mr-2"></i>
                <strong>Das lässt sich nicht rückgängig machen.</strong>
              </div>

              <div v-if="reportType === 'user'">
                <p class="mt-3 mb-2">
                  Gelöscht wird nicht die Meldung, sondern der
                  <strong>gemeldete Benutzer</strong> mit allem, was zu ihm gehört:
                </p>
                <ul class="delete-list">
                  <li>Benutzerkonto und Profil</li>
                  <li>Alle Beiträge und Kommentare</li>
                  <li>Alle Touren und Fahrzeuge</li>
                  <li>Alle Nachrichten und Verbindungen</li>
                </ul>
              </div>
              <p class="mt-3 mb-0" v-else>
                Gelöscht wird nicht die Meldung, sondern der gemeldete Inhalt
                selbst. Er verschwindet damit auch aus der App.
              </p>

              <div class="delete-target mt-3" v-if="viewReport">
                <!-- Zuvor stand hier fest `viewReport.image`. Weder der
                     Strecken- noch der Beitrags-Zweig im Backend liefert dieses
                     Feld (userActionController.js: bei 'route' nur _id, title,
                     description, data, reportCount, lastReportedAt; bei 'post'
                     galleryImages statt image). $img fällt bei leerem Wert auf
                     /images/brand/favicon.png zurück — im Lösch-Dialog stand
                     also das App-Symbol neben „Das lässt sich nicht rückgängig
                     machen." und sah aus wie das Bild des Löschziels. -->
                <img
                  v-if="deleteTargetImage"
                  v-bind:src="`${$img(deleteTargetImage, $awsSmallImages)}`"
                  alt=""
                  class="avatar avatar-md brround mr-3"
                />
                <div>
                  <div>{{ deleteTargetName }}</div>
                  <small class="text-muted">{{ viewReport.email || viewReport.description }}</small>
                </div>
              </div>
            </v-card-text>
            <v-divider></v-divider>
          <v-card-actions>
              <v-spacer></v-spacer>
              <a class="btn btn-secondary btn-pill mr-1" @click="deleteDialog=false">Abbrechen</a>
              <a class="btn btn-danger btn-pill" @click="takeAction(viewReport)">
                {{ reportType === 'user' ? 'Benutzer endgültig löschen' : 'Inhalt endgültig löschen' }}
              </a>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      </div>
    </div>
  
</div>
</template>

<script>
// Mehr Melder passen nicht in eine Tabellenzeile, ohne sie zu sprengen
const MAX_VISIBLE_REPORTERS = 3;

// WAR FALSCH: reporter.reason kam unübersetzt als interner Schlüssel aus dem
// Backend an (ETSBackend/helpers/inputValidation.js, REPORT_REASONS) und
// wurde unverändert angezeigt — "INAPPROPRIATE", "PORNOGRAPHY", "VIOLENCE"
// mitten in einer sonst durchgehend deutschen Oberfläche. Die deutschen
// Texte liegen bereits vor (ETSBackend/helpers/locale.json), wurden bisher
// aber nur für die Benachrichtigungs-E-Mail verwendet, nicht im Dashboard.
const REPORT_REASON_LABELS = {
  PORNOGRAPHY: 'Pornografie',
  VIOLENCE: 'Gewalt',
  INAPPROPRIATE: 'Unangemessen',
};

export default {

  components: {
  },

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 25,
      sort: null,
      order: true,
      search: "",
      convertedTenants: [],
      tenantFilter: null,
      emailRules: [
        (v) => !!v || "E-mail is required",
        // WAR FALSCH: (\.\w{2,3})+ verlangte am Ende zwingend zwei bis drei
        // Zeichen. Dieselbe Regel in Users.vue lehnte damit gültige Adressen
        // wie max@firma.info oder max@firma.online ab. {2,24} deckt auch
        // längere, heute übliche Endungen ab.
        (v) =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,24})+$/.test(v) ||
          "E-mail must be valid",
      ],
      rules: [(value) => !!value || this.$t("required")],
      tenants: [
        {
          name: '',

        }
      ],
      roles: [],
      menu: false,
      createmode: true,

      // Personal Data
      me: null,

    reports: [
    ],
    // Trennt "lädt gerade" von "wirklich leer" von "Abruf gescheitert" —
    // siehe Kommentar in fetchReported()/searchReport() und die Leerzeilen
    // im Template (vier Reiter, dieselbe "reports"-Liste).
    loading: false,
    fetchError: '',
    reportType: '',
    viewReport: {
        _id: "",
        username: "",
        email: "",
        image: "",
        about: "",
        data : [
            {}
        ],
        galleryImages: [{}],
    },

    // Anzahl der zuletzt geladenen Einträge. Fehlte in `data()`, wurde aber an
    // fünf Stellen gesetzt und gelesen — in Vue 2 entsteht so ein gewöhnliches
    // Feld am Objekt, das nicht beobachtet wird und beim Neuaufbau der
    // Komponente nicht mit zurückgesetzt wird. `null` heisst „noch nichts
    // geladen" und lässt das Nachladen beim Scrollen zu (siehe
    // infiniteScrolling); dieselbe Schreibweise nutzt Users.vue.
    lastReports: null,

    viewDialog: false,
    deleteDialog: false,
    // Sperre gegen den zweiten Klick, solange gelöscht wird
    isDeleting: false,
    reportTab: null,
    // Verzögert die Suche um 300 ms, wie schon in Crews.vue. Ohne das ging
    // pro Tastendruck eine eigene Serveranfrage raus.
    searchTimer: null,
    };
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    // Die Seitenzahl wird hier NICHT mehr gesetzt: Sie gehört dorthin, wo die
    // Liste ersetzt wird (fetchReported und searchReport), sonst fehlt sie in
    // genau einem Zweig. Zuvor stand `this.page = 0` nur im Suchzweig — wer
    // suchte, bis Seite 3 scrollte und dann das Suchfeld leerte, bekam über
    // fetchReported die ersten 25 Einträge, während `page` auf 3 stehen blieb.
    // Der nächste Scroll fragte skip: 100 an; die Einträge 25 bis 99 bekam
    // niemand zu sehen.
    //
    // WAR FALSCH: Jeder Tastendruck löste sofort eine eigene Serveranfrage
    // aus. Jetzt wird wie in Crews.vue 300 ms gewartet und ein noch nicht
    // abgeschickter Zeitgeber verworfen, bevor ein neuer gesetzt wird.
    search: function () {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        if (this.search == "") {
          this.fetchReported();
        } else {
          this.searchReport();
        }
      }, 300);
    },
  },

  mounted() {
    this.chooseReportType('user');
  },

  beforeDestroy() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  },

  computed: {
    /** Benennt im Lösch-Dialog, was tatsächlich verschwindet. */
    deleteDialogTitle() {
      if (this.reportType === 'user') return 'Benutzer endgültig löschen?';
      if (this.reportType === 'trip') return 'Tour endgültig löschen?';
      // Fehlte: Für 'route' fiel die Überschrift auf den Rückfall durch und
      // versprach, einen „Beitrag" zu löschen — tatsächlich verschwindet die
      // gemeldete Strecke. Wer den Dialog liest, prüft an der falschen Sache.
      if (this.reportType === 'route') return 'Strecke endgültig löschen?';
      return 'Beitrag endgültig löschen?';
    },

    /**
     * Benennt das Löschziel im Dialog.
     *
     * Zuvor stand hier `userName || title || 'Beitrag'`. Der Titel einer
     * Strecke hat in ETSBackend/models/Route.js den Vorgabewert '' — leer ist
     * falsy, also griff der Rückfall: Die Überschrift sagte „Strecke endgültig
     * löschen?", das Ziel darunter aber „Beitrag". Die Tabelle schreibt an
     * derselben Stelle „ohne Titel", und dabei bleibt es jetzt auch hier.
     */
    deleteTargetName() {
      const target = this.viewReport || {};
      if (this.reportType === 'user') return target.userName || 'ohne Namen';
      if (this.reportType === 'trip' || this.reportType === 'route') {
        return target.title || 'ohne Titel';
      }
      // Beiträge haben weder Titel noch Namen — dort ist „Beitrag" richtig.
      return 'Beitrag';
    },

    /**
     * Bild des Löschziels — leer, wenn der gemeldete Typ keines mitliefert.
     * Ein leerer Wert lässt das Bild ganz weg, statt über den Rückfall in
     * main.js das App-Symbol als vermeintliches Bild des Inhalts zu zeigen.
     */
    deleteTargetImage() {
      const target = this.viewReport || {};
      // Strecken haben kein Bildfeld (models/Route.js), und der Strecken-Zweig
      // im Backend gibt auch die galleryImages nicht mit heraus.
      if (this.reportType === 'route') return '';
      // Beiträge liefern galleryImages statt image — dieselbe Absicherung wie
      // in der Tabelle, denn ein Beitrag darf auch ohne Bild gemeldet werden.
      if (this.reportType === 'post') return this.firstImage(target);
      return target.image || '';
    },
  },

  methods: {
    /**
     * Erstes Bild eines gemeldeten Beitrags — mit Absicherung, weil ein
     * Beitrag auch ohne Bild gemeldet werden kann.
     */
    firstImage(report) {
      if (!report || !report.galleryImages || report.galleryImages.length === 0) return '';
      return report.galleryImages[0].url;
    },

    /** Übersetzt den internen Meldegrund-Schlüssel ins Deutsche. */
    reasonLabel(reason) {
      if (!reason) return 'ohne Angabe';
      return REPORT_REASON_LABELS[reason] || reason;
    },

    /** Wie oft ein Eintrag gemeldet wurde. */
    reportCount(report) {
      if (report.reportCount != null) return report.reportCount;
      return report.data ? report.data.length : 0;
    },

    /**
     * Die ersten Melder einer Meldung. Mehr als drei sprengen die Zeile —
     * der Rest steht als Anzahl darunter.
     */
    visibleReporters(report) {
      return report.data ? report.data.slice(0, MAX_VISIBLE_REPORTERS) : [];
    },

    hiddenReporterCount(report) {
      if (!report.data) return 0;
      return Math.max(0, report.data.length - MAX_VISIBLE_REPORTERS);
    },

    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
            setTimeout(() => {
                var _this = this;
                if(this.lastReports == this.ElementPerPage || this.lastReports == null){
                  // WAR FALSCH: this.page wurde in beiden Zweigen VOR der
                  // Anfrage hochgezählt. Scheiterte sie (Netzstörung, 401,
                  // 500), blieb der Zähler trotzdem erhöht — die betroffenen
                  // 25 Einträge waren dauerhaft übersprungen, nur ein
                  // Neuladen der Seite half. Jetzt steigt die Seitenzahl erst
                  // NACH einer erfolgreichen Antwort, wie schon in Users.vue
                  // (naechsteSeite) und BlacklistedUsers.vue.
                  const naechsteSeite = this.page + 1;
                  // Reiter und Suchbegriff, wie sie beim Abschicken galten.
                  //
                  // WAR FALSCH: Beide Zweige hatten denselben Anhänge-Code
                  // doppelt und ohne jede Prüfung, WOZU die eintreffenden
                  // Zeilen eigentlich gehören. Wechselt der Verwalter den
                  // Reiter, während eine Nachlade-Anfrage unterwegs ist (die
                  // startet ohnehin erst 500 ms nach dem Scrollen), hängte die
                  // Antwort ihre Zeilen an die inzwischen ganz andere Liste:
                  // gemeldete Benutzer unter den Spaltenköpfen für gemeldete
                  // Beiträge. chooseReportType() leert die Liste zwar beim
                  // Wechsel, gegen eine bereits laufende Anfrage hilft das
                  // nicht. Jetzt verwirft der Anhänger alles, was nicht mehr
                  // zum aktuellen Reiter und Suchbegriff passt.
                  const typ = this.reportType;
                  const begriff = this.search;
                  const anhaengen = function (response) {
                    if (_this.reportType !== typ || _this.search !== begriff) return;
                    // Ein fachlicher Fehlschlag (HTTP 200 mit success:false)
                    // sah bisher exakt aus wie "die Liste ist zu Ende" und
                    // blieb stumm — während ein Netzfehler an derselben Stelle
                    // längst gemeldet wird (.catch -> onError).
                    if (response.data != null && response.data.success === false) {
                      _this.lastReports = 0;
                      _this.onError(response.data);
                      return;
                    }
                    const neue = (response.data && response.data.data) || [];
                    _this.lastReports = neue.length;
                    if(neue.length >= 1) {
                      _this.page = naechsteSeite;
                      neue.forEach(item => _this.reports.push(item));
                    }
                  };
                  if(begriff ==  "" || begriff == null){
                    const body = {
                      type: typ,
                      skip: naechsteSeite * this.ElementPerPage,
                      limit: this.ElementPerPage,
                    }
                    // Muss POST sein: Die Route gibt es nur als POST, und die
                    // Angaben gehören in den Rumpf. Als zweites Argument eines
                    // GET wäre `body` die Konfiguration — Typ, Beginn und
                    // Anzahl gingen verloren, die Anfrage lief ins 404.
                    this.$axios
                          .post('/report/detailWithLimit', body)
                          .then(anhaengen)
                          .catch(_this.onError);
                  }
                  else{
                    // Ohne encodeURIComponent zerlegte ein "/" oder "?" im
                    // Suchbegriff den Pfad — /report/search/user/a/b/0/25 trifft
                    // keine Route und antwortete mit 404 statt mit einer Liste.
                    this.$axios
                          .get('/report/search/'+ typ + '/' + encodeURIComponent(begriff) +'/'+ naechsteSeite * this.ElementPerPage + '/' + this.ElementPerPage)
                          .then(anhaengen)
                          .catch(_this.onError);
                  }
                }
            }, 500);
        }
    },
    fetchReported() {
      var _this = this;
      // Diese Abfrage ERSETZT die Liste (reports = ..., nicht push) — also
      // gehört die Seitenzahl zurück auf Anfang. Ohne das blieb sie stehen:
      // Suchen, bis Seite 3 scrollen, Suchfeld leeren — die Liste begann
      // wieder bei 0, das nächste Nachladen aber bei skip: 100.
      this.page = 0;
      // WAR FALSCH: Es gab keine "lädt gerade"-Anzeige und keine Trennung
      // zwischen "wirklich leer" und "Abruf ist fehlgeschlagen" — die
      // Leerzeilen im Template standen dadurch auch WÄHREND des Ladens und
      // bei einem Fehlschlag da. Wie in Users.vue trennen loading/fetchError
      // jetzt die drei Zustände.
      this.loading = true;
      this.fetchError = '';
      // Der Reiter, wie er beim Abschicken galt. Wechselt der Verwalter
      // schnell hin und her, laufen zwei Abfragen gleichzeitig — und die
      // langsamere kommt zuletzt an. Ohne diese Prüfung schriebe sie die
      // Zeilen des ALTEN Reiters unter die Spaltenköpfe des neuen, genau das
      // Bild, gegen das der Rest dieser Datei bereits abgesichert wurde.
      const typ = this.reportType;
      const body = {
        type: typ,
        skip: this.page * this.ElementPerPage,
        limit: this.ElementPerPage,
      }
      this.$axios.post('/report/detailWithLimit', body).then(function(response){
        if (_this.reportType !== typ) return;
        _this.loading = false;
        // WAR FALSCH: response.data.success wurde nicht geprüft und
        // response.data.data ungeprüft in reports geschrieben. Bei einem
        // fachlichen Fehlschlag (HTTP 200, success:false, z.B. unbekannter
        // Typ) hat dieses Backend KEIN data-Feld — reports.length griff dann
        // auf undefined zu und die Seite stürzte beim Zeichnen ab.
        if (response.data == null || response.data.success === false) {
          _this.reports = [];
          // Auf 0 statt unberührt: lastReports steuert, ob beim Scrollen
          // nachgeladen wird. Blieb der alte Wert stehen, hängte das Nachladen
          // weiter Seiten an eine Liste, die wegen fetchError gar nicht
          // angezeigt wird.
          _this.lastReports = 0;
          _this.fetchError = (response.data && response.data.message) || 'Der Server hat die Anfrage abgelehnt.';
          return;
        }
        _this.reports = response.data.data || [];
        _this.lastReports = _this.reports.length;
      }).catch(function(error){
        if (_this.reportType !== typ) return;
        _this.loading = false;
        // WAR FALSCH (Runde 2): Hier wurde nur fetchError gesetzt, die alte
        // Liste blieb stehen — Fehlermeldung und veraltete Meldungsliste
        // standen danach gleichzeitig auf dem Bildschirm, beim Reiterwechsel
        // sogar unter den falschen Spaltenköpfen. Diese Abfrage ERSETZT die
        // Liste; scheitert sie, gibt es keine gültige Liste mehr.
        _this.reports = [];
        _this.lastReports = 0;
        _this.fetchError = _this.serverMessage(error);
        _this.onError(error);
      });
    },
    onError(err) {
      if (err != null && err.response != null && err.response.data != null) {
        // this.console gibt es nicht — der Fehlerbehandler warf hier selbst.
        console.error(err.response.data);
      } else {
        console.error(err);
      }
      // WAR FALSCH: Dieser Behandler schrieb nur in die Entwicklerkonsole.
      // Ein fehlgeschlagener Abruf sah dadurch genauso aus wie "keine
      // Meldungen vorhanden". Bei 401/403 bleibt es bei der zentralen Meldung
      // aus main.js.
      const status = err != null && err.response != null ? err.response.status : null;
      if (status === 401 || status === 403) return;
      // WAR FALSCH: Der Haken "Bearbeitet" und das Löschen reichen hier den
      // ANTWORTKÖRPER herein ({success:false, message:"…"}). Der Text darin
      // ging verloren und der Verwalter las nur "Etwas ist schief gelaufen".
      const message = this.failureMessage(err);
      if (message) {
        this.$noty.error(message);
        return;
      }
      this.$showCommonError();
    },
    // Liefert AUSSCHLIESSLICH den Klartext, den der Server geschickt hat —
    // sonst null. Zwei Formen: Axios-Fehler (Text in err.response.data) und
    // der Antwortkörper eines fachlichen Fehlschlags ({success:false,
    // message:"…"} mit HTTP 200), den die schreibenden Aktionen direkt
    // hereinreichen. Bewusst NICHT err.message eines Axios-Fehlers: Das ist
    // der technische englische Text ("Network Error"). Wie in Users.vue.
    failureMessage(err) {
      if (err == null) return null;
      if (err.response != null && err.response.data != null && err.response.data.message) {
        return err.response.data.message;
      }
      if (err.response == null && err.success === false && err.message) {
        return err.message;
      }
      return null;
    },
    // Liefert einen anzeigbaren Text zu einem fehlgeschlagenen Abruf, für die
    // Fehlerzeile in der Tabelle. Gleiches Muster wie in Crews.vue/Users.vue.
    serverMessage(error, fallback) {
      return this.failureMessage(error) || fallback || 'Die Anfrage ist fehlgeschlagen.';
    },
    // Lädt die Meldungen so neu, wie sie gerade angezeigt werden.
    //
    // WAR FALSCH: Der Haken "Bearbeitet" und das Löschen einer Meldung riefen
    // fest fetchReported() auf — und das holt IMMER alle Meldungen des
    // aktuellen Reiters. Wer nach einem Namen gesucht, den einen Treffer
    // abgehakt und dann hingesehen hat, fand im Suchfeld weiter seinen Begriff,
    // in der Tabelle darunter aber alle Meldungen. Es sah aus, als hätte sich
    // die Suche von selbst zurückgesetzt. Genau dieser Fehler wurde in
    // Users.vue (reloadUsers), BlacklistedUsers.vue und UserAutos.vue schon
    // behoben — auf dieser Seite blieb er stehen.
    reloadReports() {
      if (this.search == null || this.search === "") {
        this.fetchReported();
      } else {
        this.searchReport();
      }
    },
    openViewReport(report) {
      this.viewReport = report;
      this.viewDialog = true;
      console.log(this.viewReport);
    },
    openDeleteReport(report) {
      this.viewReport = report;
      this.deleteDialog = true;


    },
    chooseReportType(type) {
        this.reportType = type;

        // WAR FALSCH (Runde 2): Der Reitername wurde sofort umgestellt, die
        // Liste behielt aber die Meldungen des alten Reiters, bis die neue
        // Antwort da war — und bei einem Fehlschlag für immer. Unter den
        // Spaltenköpfen "Gemeldete Beiträge" standen dann die Zeilen der
        // gemeldeten Benutzer. Beim Wechsel gehört die alte Liste weg: Sie
        // gehört zu einem anderen Typ und ist für den neuen Reiter in keinem
        // Fall richtig. Danach greift die Ladeanzeige ("Wird geladen …"), weil
        // die Liste jetzt tatsächlich leer ist.
        this.reports = [];
        this.lastReports = null;
        this.fetchError = '';

        // WAR FALSCH: Hier stand unbedingt this.fetchReported() — der
        // Suchbegriff im Feld blieb dabei unberücksichtigt. Wer im Reiter
        // "Gemeldete Benutzer" nach einem Namen suchte und dann auf
        // "Gemeldete Beiträge" wechselte, sah dort plötzlich ALLE Beiträge,
        // obwohl im Suchfeld noch der Begriff stand. Jetzt entscheidet wie
        // beim Beobachter am Suchfeld: mit Suchbegriff wird gesucht, ohne
        // wird die volle Liste geholt.
        //
        // `page` behielt beim Reiterwechsel sonst den Stand des vorherigen
        // Reiters — das ist weiterhin durch das Zurücksetzen in
        // fetchReported()/searchReport() selbst abgedeckt.
        if (this.search) {
          this.searchReport();
        } else {
          this.fetchReported();
        }
    },
    searchReport() {
      var _this = this;
      // Auch diese Abfrage ersetzt die Liste, also zurück auf Seite 0.
      this.page = 0;
      this.loading = true;
      this.fetchError = '';
      // Reiter und Suchbegriff, wie sie beim Abschicken galten — siehe
      // fetchReported(): Die langsamere von zwei gleichzeitigen Abfragen darf
      // die Liste nicht mehr überschreiben, wenn inzwischen etwas anderes
      // angezeigt wird.
      const typ = this.reportType;
      const begriff = this.search;
      this.$axios
        .get(
          // Ohne encodeURIComponent zerlegte ein "/" oder "?" im Suchbegriff den
          // Pfad — die Suche antwortete mit 404 statt mit einem Ergebnis.
          //
          // Hier stand `this.page` roh als skip. Das Nachladen beim Scrollen
          // schickt an dieselbe Route `this.page * this.ElementPerPage` — zwei
          // Rechnungen für denselben Parameter. Bei page: 1 hätte die eine
          // 1 Eintrag übersprungen, die andere 25; die Route erwartet die
          // Anzahl zu überspringender Einträge (routes/V1.js: :skip).
          "/report/search/" +
            typ + "/" +
            encodeURIComponent(begriff) +
            "/" +
            this.page * this.ElementPerPage +
            "/" +
            this.ElementPerPage
        )
        .then(function (response) {
          if (_this.reportType !== typ || _this.search !== begriff) return;
          _this.loading = false;
          if (response.data == null || response.data.success === false) {
            _this.reports = [];
            _this.lastReports = 0;
            _this.fetchError = (response.data && response.data.message) || 'Der Server hat die Anfrage abgelehnt.';
            return;
          }
          _this.reports = response.data.data || [];
          _this.lastReports = _this.reports.length;
        })
        .catch(function(error){
          if (_this.reportType !== typ || _this.search !== begriff) return;
          _this.loading = false;
          // Siehe fetchReported(): Die alte Liste blieb im Fehlerfall stehen
          // und stand dann zusammen mit der Fehlerzeile auf dem Bildschirm.
          _this.reports = [];
          _this.lastReports = 0;
          _this.fetchError = _this.serverMessage(error);
          _this.onError(error);
        });
    },
    takeAction(report) {
      // Der Dialog blieb nach dem Löschen offen — bei einer Aktion, die ein
      // ganzes Konto entfernt, lädt das zum zweiten Klick ein.
      if (this.isDeleting) return;

      let _this = this;
      const reportToTakeAction = {
        id: report._id,
        type: this.reportType,
      }
      this.isDeleting = true;
      this.$axios.post('/report/takeAction', reportToTakeAction).then(function (response) {
        _this.isDeleting = false;
        // WAR FALSCH: Der Erfolgszweig meldete ungeprüft "gelöscht". Der Server
        // antwortet auch bei einem fachlichen Fehlschlag mit HTTP 200 und
        // success:false (userActionController.reportUserAction, Zweig
        // `default`) — bei einer so endgültigen Aktion darf die Meldung nicht
        // raten, sondern muss die Antwort lesen.
        if (response.data != null && response.data.success === false) {
          _this.onError(response.data);
          return;
        }
        _this.$noty.success(
          _this.reportType === 'user'
            ? 'Der Benutzer wurde mit allen Inhalten gelöscht.'
            : 'Der gemeldete Inhalt wurde gelöscht.',
        );
        _this.deleteDialog = false;
        _this.viewDialog = false;
        // reloadReports() statt fetchReported(): behält einen laufenden
        // Suchbegriff bei, siehe Kommentar an der Methode.
        _this.reloadReports();
      }).catch(function(error){
        _this.isDeleting = false;
        _this.$noty.error('Das Löschen ist fehlgeschlagen.');
        console.error(error);
      })
    },
    setChecked(report, event) {
      // WAR FALSCH (Runde 1): Ein Klick räumte sämtliche Meldungen zu diesem
      // Objekt sofort und endgültig weg — jetzt wird vorher gefragt. Neu
      // kaputt dadurch: Ein Ankreuzfeld im Browser setzt sich selbst um,
      // BEVOR der @click-Handler überhaupt läuft. Klickte der Verwalter auf
      // "Abbrechen", stieg der Handler hier früh aus — die vom Browser schon
      // vorgenommene Umstellung wurde nie zurückgenommen, das Kästchen blieb
      // sichtbar angehakt, obwohl nichts passiert war. Das Feld ist an
      // keinen Wert gebunden (kein v-model), kann den echten Zustand also
      // nicht selbst darstellen. event.preventDefault() verhindert jetzt die
      // automatische Umstellung von vornherein — bei Bestätigung UND Erfolg
      // verschwindet die ganze Zeile ohnehin per fetchReported() (der Server
      // liefert erledigte Meldungen nicht mehr mit), ein manuelles Ankreuzen
      // ist also nicht nötig.
      if (event) event.preventDefault();
      if (!window.confirm('Alle Meldungen zu diesem Eintrag als bearbeitet markieren? Das lässt sich nicht rückgängig machen.')) {
        return;
      }
      let _this = this;
      const reportToCheck = {
        id: report._id
      }
      this.$axios.put('/report/checked', reportToCheck).then(function (response) {
        // WAR FALSCH: response.data.success wurde nicht geprüft. respondFailure
        // antwortet mit HTTP 200 und success:false — das landete bisher
        // unbemerkt im Erfolgszweig und lud die Liste neu, als sei nichts
        // gewesen.
        if (response.data != null && response.data.success === false) {
          _this.onError(response.data);
          return;
        }
        // reloadReports() statt fetchReported(): behält einen laufenden
        // Suchbegriff bei, siehe Kommentar an der Methode.
        _this.reloadReports();
      })
      .catch(function(error){
        _this.onError(error);
      })
    }

  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}

/* Gestaltung des Erklärtexts: siehe `views/App.vue`, dort einmal zentral. */

/* Melder mit Bild, Name und Begründung untereinander */
.reporter-entry {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.reporter-entry:last-child {
  margin-bottom: 0;
}

.reporters-cell {
  min-width: 260px;
  white-space: normal;
}

/* Die Tabellenköpfe schreiben jedes Wort groß — bei einem ganzen Satz stört das */
.reporters-head {
  text-transform: none !important;
}

/* Warnung im Lösch-Dialog — hier verschwindet ein ganzes Konto */
.delete-warning {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(220, 53, 69, 0.12);
  color: #e05260;
}

.delete-list {
  margin: 0;
  padding-left: 20px;
  font-size: 13px;
}

.delete-target {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(148, 163, 184, 0.12);
}

.reported-about {
  display: block;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tableAbout {
  max-width: 260px;
  white-space: normal;
}
</style>

